export default function (http) {
    return {

        query (data){
            return http.json({
                url: '/order/base/query',
                data
            });
        },
        queryDay(data){
            return http.json({
                url: '/trade/info/queryDay',
                data
            });

        },
        queryHis(data){
            return http.json({
                url: `/trade/info/queryHis?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });

        }
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/trade.js